module.exports = __webpack_public_path__ + "img/kankou_22.188bc295.jpg";